import React, { useState } from 'react';
import { useRedactionMode } from '../../contexts/RedactionModeContext';

interface RedactionBlurProps {
  children: React.ReactNode;
  /** Force blur regardless of PII detection (for known PII fields) */
  forceBlur?: boolean;
  /** Custom blur radius in pixels (default: 5) */
  blurRadius?: number;
  /** Whether this content can be revealed on hover (default: true) */
  revealOnHover?: boolean;
}

export const RedactionBlur: React.FC<RedactionBlurProps> = ({
  children,
  forceBlur = false,
  blurRadius = 5,
  revealOnHover = true,
}) => {
  const { isEnabled } = useRedactionMode();
  const [revealed, setRevealed] = useState(false);

  if (!isEnabled || !forceBlur) {
    return <>{children}</>;
  }

  return (
    <span
      className={`inline transition-all duration-200 rounded-sm ${
        revealed ? '' : 'select-none bg-amber-100/50 dark:bg-amber-900/20'
      }`}
      style={{
        filter: revealed ? 'none' : `blur(${blurRadius}px)`,
        cursor: revealOnHover ? 'pointer' : 'default',
      }}
      onMouseEnter={() => revealOnHover && setRevealed(true)}
      onMouseLeave={() => setRevealed(false)}
      onClick={() => revealOnHover && setRevealed(prev => !prev)}
      aria-label="Redacted content — hover to reveal"
      role="text"
    >
      {children}
    </span>
  );
};
